import MetaProperties from "../../../../Global/Models/Pagination/MetaProperties";
import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import BaseRemapper from "../../../../Global/Remapper/BaseRemapper";
import ContextModel from "../../../Activity/Models/RequestBody/Context/ContextModel";
import TagsModel from "../../../Activity/Models/RequestBody/Context/TagsModel";
import PollBasicModel from "../Polls/PollBasicModel";
import PollFullModel from "../Polls/PollFullModel";
import PollOptionModel from "../Polls/PollOptionModel";
import PollVoteFullModel from "../Polls/PollVoteFullModel";
import PollsModel from "../Polls/PollsModel";
import PollsUserVotesModel from "../Polls/PollsUserVotesModel";
import PreferenceMappingModel from "../../../../Global/Models/PreferenceMapping/PreferenceMappingModel";
import PreviousPollVoteModel from "../Polls/PreviousPollVoteModel";
import SinglePollVoteModel from "../Polls/SinglePollVoteModel";
import PollVoteBasicModel from "../Polls/PollVoteBasicModel";

export default class PollRemapper extends BaseRemapper {
  public remapPolls = (data: any) => {
    const model = new PollsModel();
    model.meta.pagination = this.remapMetaPagination(data.meta.pagination);
    model.data = data.data.map((value) => this.remapPoll(value));

    return model;
  };

  public remapPollById = (data: any) => {
    const model = new PollFullModel();

    model.id = data.id;
    model.title = data.title;
    model.alternativeTitle = data.alternative_title;
    model.description = data.description;
    model.type = data.type;
    model.images = data.images;
    model.status = data.status;
    model.language = data.language;
    model.authRequirement = data.auth_requirement;
    model.flags = data.flags;
    model.totalVotes = data.total_votes;
    model.customFields = data.custom_fields;
    model.related = data.related ? this.remapRelated(data.related) : [];
    model.branding = data.branding ? this.remapBranding(data.branding) : null;
    model.embedCode = data.embed_code;
    model.labels = data.labels;
    model.rules = data.rules;
    model.adContent = data.ad_content;
    model.options = data.options ? this.remapOptions(data.options) : [];
    model.context = data.context
      ? this.remapContext(data.context)
      : data.context;
    model.preferencesEnabled = data.preferences_enabled;
    model.multipleChoice = data.multiple_choice;
    model.maxMultipleChoiceOptions = data.max_multiple_choice_options;
    model.participationCount = data.participation_count;
    model.maxAttempts = data.max_attempts;
    model.externalActivity = data.external_activity;
    model.createdAt = data.created_at;
    model.updatedAt = data.updated_at;

    return model;
  };

  public remapUserVote = (data: any) => {
    const model = new SinglePollVoteModel();

    model.id = data.id;
    model.pollId = data.poll_id;
    model.optionId = data.option_id;
    model.optionIds = data.option_ids;
    model.userId = data.user_id;
    model.attempts = data.attempts || null;
    model.previousVotes = data.previous_votes
      ? data.previous_votes.map((value) => this.remapPreviousVotes(value))
      : [];
    model.createdAt = data.created_at;

    return model;
  };

  private remapPreviousVotes = (data: any) => {
    const model = new PreviousPollVoteModel();

    model.id = data.id;
    model.pollId = data.poll_id;
    model.optionIds = data.option_ids;
    model.userId = data.user_id;
    model.createdAt = data.created_at;

    return model;
  };

  public remapPollsVotes = (data: any) => {
    const model = new PollsUserVotesModel();

    model.meta.pagination = this.remapMetaPagination(data.meta.pagination);
    model.data = data.data.map((value) => this.remapAllPollsVotes(value));

    return model;
  };

  private remapAllPollsVotes = (data: any) => {
    const model = new PollVoteBasicModel();

    model.id = data.id;
    model.pollId = data.poll_id;
    model.optionId = data.option_id;
    model.optionIds = data.option_ids;
    model.userId = data.user_id;
    model.createdAt = data.created_at;

    return model;
  };

  public remapSinglePollVote = (data: any) => {
    const model = new PollVoteFullModel();

    model.id = data.id;
    model.pollId = data.poll_id;
    model.optionId = data.option_id;
    model.optionIds = data.option_ids;
    model.userId = data.user_id;
    model.attempts = data.attempts || null;
    model.createdAt = data.created_at;
    model.previousVotes = data.previous_votes
      ? data.previous_votes.map((value) => this.remapPreviousVotes(value))
      : [];

    return model;
  };

  private remapMetaPagination = (pagination: any) => {
    const model = new MetaProperties();

    model.itemsPerPage = pagination.items_per_page;
    model.nextPageStartsAfter = pagination.next_page_starts_after;

    return model;
  };

  private remapPoll = (data: any) => {
    const model = new PollBasicModel();

    model.id = data.id;
    model.title = data.title;
    model.alternativeTitle = data.alternative_title;
    model.description = data.description;
    model.type = data.type;
    model.images = data.images;
    model.status = data.status;
    model.language = data.language;
    model.authRequirement = data.auth_requirement;
    model.flags = data.flags;
    model.totalVotes = data.total_votes;
    model.customFields = data.custom_fields;
    model.related = data.related ? this.remapRelated(data.related) : [];
    model.branding = data.branding ? this.remapBranding(data.branding) : null;
    model.embedCode = data.embed_code;
    model.labels = data.labels;
    model.adContent = data.ad_content;
    model.options = data.options ? this.remapOptions(data.options) : [];
    model.context = data.context
      ? this.remapContext(data.context)
      : data.context;
    model.preferencesEnabled = data.preferences_enabled;
    model.multipleChoice = data.multiple_choice;
    model.maxMultipleChoiceOptions = data.max_multiple_choice_options;
    model.participationCount = data.participation_count;
    model.maxAttempts = data.max_attempts;
    model.externalActivity = data.external_activity;
    model.createdAt = data.created_at;
    model.updatedAt = data.updated_at;

    return model;
  };

  private remapContext = (data: any) => {
    const model = new ContextModel();

    model.content = data.content;
    model.tags = data.tags
      ? data.tags.map((value) => {
          const newTag = new TagsModel();

          newTag.id = value.id;
          newTag.type = value.type;
          newTag.source = value.source;

          return newTag;
        })
      : null;
    model.campaign = data.campaign;

    return model;
  };

  private remapRelated = (response: any[]) => {
    return response.map((r) => {
      const model = new RelatedEntityRelationship();

      model.entityId = r.entity_id;
      model.entityType = r.entity_type;
      model.entityRelationship = r.entity_relationship;

      return model;
    });
  };

  private remapOptions = (response: any[]) => {
    return response.map((r) => {
      const model = new PollOptionModel();

      model.id = r.id;
      model.title = r.title;
      model.description = r.description;
      model.images = r.images;
      model.votes = r.votes;
      model.embedCode = r.embed_code;
      model.preferencesMapping = r.preferences_mapping
        ? this.remapPreferencesMapping(r.preferences_mapping)
        : [];

      return model;
    });
  };

  private remapPreferencesMapping = (response: any[]) => {
    return response.map((r) => {
      const model = new PreferenceMappingModel();

      model.preferenceId = r.preference_id;

      return model;
    });
  };
}
